import { Typography } from "@stardust-ds/react"
import intl from "react-intl-universal"

import styles from "./index.module.scss"
import MembersIcon from "../../../assets/icons/MembersIcon"
import TrashIcon from "../../../assets/icons/TrashIcon"
import EditIcon from "../../../assets/icons/EditIcon"
import { useContext } from "react"
import { AuthContext } from "../../../contexts/Auth"
import moment from "moment"
import { fnFormatDateFromUTC } from "../../../utils/date"

export default function EvidenceTextCard(props) {
  const {
    oData,
    cDataFieldName,
    fnEditEvidence,
    fnDeleteEvidence,
    bShowActionButtons = true,
    ...rest
  } = props
  const { oUser } = useContext(AuthContext)
  const cUserTimeZone = oUser?.data?.user_ctimezone
  if (!oData) return null

  const dateFormat = oData?.dDate.match(/^\d{2}\/\d{2}\/\d{4} - \d{2}:\d{2}$/) ? "DD/MM/YYYY - HH:mm" : "YYYY-MM-DD HH:mm:ss";
  const dMomentFormated = moment.utc(oData?.dDate, dateFormat).tz(cUserTimeZone).format("DD/MM/YYYY - HH:mm")

  return (
    <div className={styles.evidenceTextCardContainer} {...rest}>
      <div className={styles.evidenceTextContent}>
        <div className={`${styles.row} ${styles.userContainer}`}>
          <MembersIcon />
          <Typography type="h5" color="#6CB6E3">
            {oData.cUserName}
          </Typography>
        </div>
        <p className={styles.text}>{oData.opae_cvalue}</p>
        <div className={styles.footer}>
          <div className={styles.row}>
            <p className={styles.dateField}>
              {cDataFieldName || intl.get("ActivityEvidence.inclusion_date")}
            </p>
            <p className={styles.date}>{dMomentFormated}</p>
          </div>
          {bShowActionButtons && (
            <div className={styles.buttonsFooter}>
              <EditIcon
                width={"15"}
                height={"15"}
                fill={"#1ECB4F"}
                onClick={() => fnEditEvidence(oData)}
              />
              <TrashIcon
                width={"15"}
                height={"15"}
                fill={"#FF3541"}
                onClick={() => fnDeleteEvidence(oData)}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
